import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Line, Bar } from 'react-chartjs-2';
import { onValue, ref } from "firebase/database";
import {
    Chart, registerables, CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import FirebaseApp from "../firebase";
import { activeUsers, dashboard, sessionPeriod } from "../Services/userServices";
import { ComponentLoader } from "../Layout/componentLoader";
import { GraphLoader } from "../Layout/graphLoader";
import { useNavigate, useParams } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";

Chart.register(...registerables, CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend);

export const Dashboard = () => {

    const navigate = useNavigate();
    const { company_key } = useParams();
    const [comanyData, setCompanyData] = useState({});
    const [totalUsers, setTotalUsers] = useState(0);
    const [sessionTime, setSessionTime] = useState("current");
    const [activeTime, setActiveTime] = useState("last30days");
    const [keyLoader, setKeyLoader] = useState(false);
    const [apiLoader, setApiLoader] = useState(false);
    const [activeLoader, setActiveLoader] = useState(false);
    const [sessionLoader, setSessionLoader] = useState(false);
    const [data, setData] = useState({})
    const [activeData, setActiveData] = useState([])
    const [sessionData, setSessionData] = useState({})

    useEffect(() => {
        setKeyLoader(true);
        FirebaseApp().then(db => {
            const keyRef = ref(db, `CompanyKeys/${company_key}`);
            return onValue(keyRef, (snapshot) => {
                let responseVal = snapshot.val()
                setCompanyData({ "key": snapshot.key, "company_name": responseVal.company_name, "available_licenses": responseVal.available_licenses, "total_licenses": responseVal.total_licenses })
                setTotalUsers(responseVal.total_licenses-responseVal.available_licenses)
                setKeyLoader(false);
            }, (error) => {
                setKeyLoader(false);
                console.log("Error while loading the data 1", error);
            });
        }).catch(error => {
            setKeyLoader(false);
            console.error("Error initializing Firebase 1:", error);
        })
        getDashboardData();
        getActiveData(activeTime);
        getSessionData(sessionTime);
    }, [])

    const getDashboardData = () => {
        setApiLoader(true);
        dashboard(company_key).then(res => {
            setData(res.data.data)
            setApiLoader(false);
        }).catch(err => {
            console.log('error --->', err);
            setApiLoader(false);
        })
    }

    const getActiveData = (active) => {
        setActiveLoader(true);
        activeUsers(company_key, active).then(res => {
            setActiveData(res.data.active_users)
            setActiveLoader(false);
        }).catch(err => {
            console.log('error --->', err);
            setActiveLoader(false);
        })
    }

    const getSessionData = (session) => {
        setSessionLoader(true);
        sessionPeriod(company_key, session).then(res => {
            setSessionData(res.data.session_period)
            setSessionLoader(false);
        }).catch(err => {
            console.log('error --->', err);
            setSessionLoader(false);
        })
    }

    const options = {
        scales: {
            y: {
                beginAtZero: true
            }
        },
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
            },
            tooltip: {
                callbacks: {
                    label: function (value) {
                        return `MINDRESET ACTIVE USERS: ${value.formattedValue}`
                    },
                }
            }
        },
    };

    var userLabel = []

    if (activeTime === "last30days") {
        for (let i = 1; i <= 30; i++) {
            userLabel.push(i)
        }
    } else if (activeTime === "last90days") {
        for (let i = 1; i <= 90; i++) {
            userLabel.push(i)
        }
    } else if (activeTime === "last6months") {
        for (let i = 1; i <= 24; i++) {
            userLabel.push(i)
        }
    }

    const earning = {
        labels: userLabel,
        datasets: [
            {
                label: 'MINDRESET USERS',
                data: activeData,
                backgroundColor: '#FF6700',
                borderColor: '#FF6700',
            }
        ]
    }

    const BarOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            }
        },
    };
    const labels = ['Stress', 'Trauma', 'Sleeplessness', 'Anxiety', 'Fatigue', 'Depression', 'Fastreset', 'Exam Anxiety', 'Pre-Game Reset', 'On Boarding'];

    const BarData = {
        labels,
        datasets: [
            {
                label: 'MINDRESET SESSIONS',
                data: [sessionData?.stress, sessionData?.trauma, sessionData?.sleeplessness, sessionData?.anxiety, sessionData?.fatigue, sessionData?.depression, sessionData?.fastreset, sessionData?.exam_anxiety, sessionData?.pre_game_reset, sessionData?.onboarding],
                backgroundColor: 'rgba(123, 104, 238, 1)',
            },

        ],
    };

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <Row className="align-items-center mb-3">
                    <Col>
                        <h1>
                            <button
                                type="button"
                                className="back-link-icon"
                                aria-label="Go back"
                                onClick={() => navigate(-1)}
                            >
                                <BsArrowLeft aria-hidden="true" />
                            </button>
                            <span className="text-orange">{company_key}</span> Dashboard
                        </h1>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col md={3}>
                        <div className="card-shadow">
                            <img src={require('../Assets/img/img1.png')} className="img-responsive" alt="img" />
                            <div className="card-content">
                                <p>Total Users</p>
                                <h2 className="text-orange f-700">{keyLoader ? <ComponentLoader /> : totalUsers}</h2>
                            </div>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="card-shadow">
                            <img src={require('../Assets/img/img2.png')} className="img-responsive" alt="img" />
                            <div className="card-content">
                                <p>Users This Month</p>
                                <h2 className="f-700">{apiLoader ? <ComponentLoader /> : data?.current_month_users ? data?.current_month_users : 0}</h2>
                            </div>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="card-shadow">
                            <img src={require('../Assets/img/img3.png')} className="img-responsive" alt="img" />
                            <div className="card-content">
                                <p>Unused Keys</p>
                                <h2 className="text-orange f-700">{keyLoader ? <ComponentLoader /> : comanyData?.available_licenses ? comanyData?.available_licenses : 0}</h2>
                            </div>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="card-shadow">
                            <img src={require('../Assets/img/img4.png')} className="img-responsive" alt="img" />
                            <div className="card-content">
                                <p>Total Sessions</p>
                                <h2 className="f-700">{apiLoader ? <ComponentLoader /> : data?.total_sessions ? data?.total_sessions : 0}</h2>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col md={6}>
                        <div className="card-shadows">
                            <div className="card-contents d-flex w-100 align-items-center justify-content-between">
                                <h6 className="f-700">Active User Chart </h6>
                                <Form.Select className="time-period d-inline mx-2" aria-label="Default select example" onChange={(e) => {
                                    getActiveData(e.target.value)
                                    setActiveTime(e.target.value)
                                }} value={activeTime}>
                                    <option value="last30days">Last 30 Days</option>
                                    <option value="last90days">Last 90 Days</option>
                                    <option value="last6months">Last 6 Months</option>
                                </Form.Select>
                            </div>
                            {activeLoader ? <GraphLoader /> : <Line data={earning} options={options} />}
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="card-shadows">
                            <div className="card-contents d-flex w-100 align-items-cente justify-content-between">
                                <h6 className="f-700">Session Chart</h6>
                                <Form.Select className="time-period d-inline mx-2" aria-label="Default select example" onChange={(e) => {
                                    getSessionData(e.target.value)
                                    setSessionTime(e.target.value)
                                }} value={sessionTime}>
                                    <option value="current">Current Month</option>
                                    <option value="last90days">Last 90 Days</option>
                                </Form.Select>
                            </div>
                            {sessionLoader ? <GraphLoader /> : <Bar options={BarOptions} data={BarData} />}
                        </div>
                    </Col>
                </Row>
            </div>
        </main >
    )

}
